<template>
  <div>
    <template v-if="$route.name === 'scorereviews'">
      <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>
      <ots-refer
        class="mb20"
        :selectList="selectList"
        :request-form="stuSelectParams"
        @search="getStudentList"
      />
      <ots-table-group-new
        :tableHeader="tableHeader"
        :tableData="tableData"
        :pagination="pagination"
        @changeNum="changeSize"
        @changePage="changePage"
      ></ots-table-group-new>
      <ots-custom-dialog :dialog.sync="applyMsgDialog" title="驳回成绩复核">
        <template v-slot:content>
          <div class="exportDialog">
            <el-form ref="exportForm" :rules="rules" :model="ruleForm">
              <el-form-item label="驳回原因" prop="auditRemark">
                <el-input
                  type="textarea"
                  v-model="ruleForm.auditRemark"
                ></el-input>
              </el-form-item>
              <el-form-item label="重新提交复核信息">
                <el-radio-group v-model="ruleForm.allowReApply">
                  <el-radio-button :label="1">允许</el-radio-button>
                  <el-radio-button :label="2">不允许</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-form>
          </div>
        </template>
        <template v-slot:footer>
          <el-button round @click="applyMsgDialog = false">取消</el-button>
          <el-button round type="primary" @click="rightAudit">确定</el-button>
        </template>
      </ots-custom-dialog>
    </template>
    <template v-else>
      <ots-main-title></ots-main-title>
      <router-view />
    </template>
  </div>
</template>
<script>
import { getPlanCourseFn } from "@/http/modules/baseSet/course";
import {
  getExamCheckStateFn,
  getPageListFn,
} from "@/http/modules/examSet/score";
import {
  getSelectPlanFn,
  catePrint,
  ConfigData,
  passthroughState,
  getSinglePlan,
  getCurrentPlanFn,
  exportDataimg,
} from "@/http/modules/examSet/examBatch";
export default {
  name: "",
  data() {
    return {
      mainTopBtnList: [
        {
          title: "导出",
          fn: this.exportScore,
        },
      ],
      Reviewitem: "",
      scoreReviewAuditEndTime: "",
      applyMsgDialog: false,
      setValuePrint: "",
      selectList: [
        {
          title: "考试批次",
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
        },
        {
          title: "审核状态",
          type: "select",
          requestKey: "auditState",
          label: "name",
          value: "id",
          data: [
            { id: "", name: "全部" },
            {
              id: "0",
              name: "待审核",
            },
            {
              id: "1",
              name: "不通过",
            },
            {
              id: "2",
              name: "已通过",
            },
          ],
        },
        {
          title: "报考课程",
          type: "select",
          requestKey: "courseId",
          label: "courseName",
          value: "courseId",
          data: [],
        },
        {
          title: "合格状态",
          type: "select",
          requestKey: "isPass",
          label: "name",
          value: "id",
          data: [
            { id: 1, name: "合格" },
            { id: 0, name: "不合格" },
          ],
        },
        {
          title: "考试状态",
          type: "select",
          multiple: true,
          requestKey: "checkState",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "关键词",
          type: "input",
          placeholder: "姓名/准考证/证件号",
          requestKey: "searchKey",
        },
      ],
      stuSelectParams: {
        planId: "",
        auditState: "",
        courseId: "",
        isPass: 0,
        searchKey: "",
        checkState: [],
      },
      stuListParams: {
        page: 1,
        size: 10,
      },
      currentPlanId: "",
      tableHeader: [
        {
          title: "考试批次",
          prop: "planName",
        },
        {
          title: "姓名",
          prop: "studentName",
        },
        {
          title: "准考证号",
          prop: "entranceCode",
        },
        {
          title: "证件号",
          prop: "cardNo",
        },
        {
          title: "分数",
          prop: "score",
        },
        {
          title: "合格状态",
          prop: "passName",
        },
        {
          title: "报考课程",
          prop: "courseName",
        },

        {
          title: "考试状态",
          prop: "checkStateName",
        },
        {
          title: "复核表",
          type: "img",
          prop: "applyFilePath",
        },
        {
          title: "审核状态",
          prop: "auditStateName",
        },
        {
          title: "提交时间",
          prop: "applyDate"
        },
        {
          title: "操作",
          type: "buttons",
          width: "260",
          btnList: [
            {
              title: (val) => {
                if (
                  val.row.auditState == 0 &&
                  this.Reviewitem < this.scoreReviewAuditEndTime
                ) {
                  return "通过";
                } else {
                  return "";
                }
              },
              click: this.passthrough,
            },
            {
              title: (row) => {
                if (this.Reviewitem > this.scoreReviewAuditEndTime) {
                  return "";
                } else {
                  if (row.row.auditState == 2 || row.row.auditState == 1) {
                    return "撤销审核";
                  } else {
                    return "驳回";
                  }
                }
              },
              click: this.reject,
            },
            {
              title: () => "详情",
              click: this.details,
            },
          ],
        },
      ],
      tableData: [],
      pagination: {
        total: 0,
      },
      ruleForm: {
        allowReApply: "1",
        auditState: "0",
        auditRemark: "",
        id: "",
      },
      rules: {
        auditRemark: [
          { required: true, message: "请填写驳回原因", trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    "stuSelectParams.planId": function (val) {
      //清空教学点和考点
      this.getStudentList();
      this.getPlanCourseData(val);
      this.getPlanData(val);
    },
  },
  created() {
    this.initData();
    this.getExamStatus();
    this.ConfigDataitemts(); 
    this.$event.$on("scoreFuHeList", this.getStudentList);
  },
  methods: {
    //获取考试状态下拉数据
    getExamStatus() {
      getExamCheckStateFn().then((res) => {
        if (res.code === 1) {
          this.$set(this.selectList[4], "data", res.data);
        }
      });
    },
    /**************************
     * @initData 初始化表单数据
     *************************/
    async initData() {
      /* *** 考试批次列表 *** */
      let { data } = await getSelectPlanFn({ needAudit: 7 });
      // let planList = [{ id: "", name: "全部" }, ...data];
      this.$set(this.selectList[0], "data", data);
      if (data.length) {
        this.stuSelectParams.planId = data[0].id;
        this.getCurrentfn();
      }
    },
    getCurrentfn() {
      // 2. 获取当前考试批次, 其它批次隐藏 (同步考生按钮);
      getCurrentPlanFn({
        planId: this.stuSelectParams.planId,
      }).then((data) => {
        this.currentPlanId = data.id;
      });
    },
    async ConfigDataitemts() {
      let { data } = await ConfigData();
      data.configList.map((e) => {
        if (e.setValue == 1) {
          this.setValuePrint = 1;
        }
      });
    },
    //考点列表
    passthrough(row) {
      passthroughState({
        allowReApply: "1",
        auditRemark: "",
        auditState: "2",
        id: row.id,
      }).then((res) => {
        this.$message.success("审核通过");
        this.getStudentList();
      });
    },
    reject(row) {
      if (row.auditState == 2 || row.auditState == 1) {
        passthroughState({
          allowReApply: "0",
          auditRemark: "",
          auditState: "0",
          id: row.id,
        }).then((res) => {
          this.$message.success("撤销审核成功");
          this.getStudentList();
        });
      } else {
        this.applyMsgDialog = true;
        this.ruleForm.auditRemark = "";
        this.ruleForm.id = row.id;
      }
    },
    details(row) {
      this.$router.push({
        path: "/scorereviews/reviewdetails",
        query: {
          planId: this.stuSelectParams.planId,
          studentCourseId: row.studentCourseId,
        },
      });
      // let revedetails = {
      //   planId:this.stuSelectParams.planId,
      //   studentCourseId:row.studentCourseId
      // }
      // usergetScoreReview(revedetails).then((res)=>{

      // })
    },

    rightAudit(val) {
      this.$refs["exportForm"].validate(async (valid) => {
        if (valid) {
          this.ruleForm.auditState = 1;
          passthroughState(this.ruleForm).then((res) => {
            this.applyMsgDialog = false;
            if (res.code == 1) {
              this.$message.success("驳回成功");
            }
            this.getStudentList();
          });
        } else {
          return false;
        }
      });
    },
    /*********************************
     * @initCourseList 课程随着批次变化
     ********************************/
    getPlanCourseData(planId) {
      getPlanCourseFn({ planId }).then(({ data }) => {
        let courseData = [
          {
            courseName: "全部",
            courseId: "",
          },
        ].concat(data);
        this.$set(this.selectList[2], "data", courseData);
      });
    },
    getPlanData(planId) {
      getSinglePlan({ planId }).then(({ data }) => {
        for (let item in this.selectPlanInfo) {
          this.selectPlanInfo[item] = data[item];
        }
        this.scoreReviewAuditEndTime = new Date(data.scoreReviewAuditEndTime).getTime();
        this.Reviewitem = new Date().getTime();
      });
    },
    isCurrentPlan() {
      return this.requestForm.planId == this.currentPlanId;
    },

    changeSize(num) {
      this.stuListParams.size = num;
      this.getStudentList();
    },
    changePage(p) {
      this.stuListParams.page = p;
      this.getStudentList(true);
    },
    async getStudentList(page) {
      let params;
      if (!page) {
        this.stuListParams.page = 1;
        params = Object.assign(this.stuListParams, this.stuSelectParams);
      } else {
        params = Object.assign(this.stuTempParams, {
          page: this.stuListParams.page,
        });
      }
      if (typeof params.stationId == "object") {
        params.stationId = params.stationId.join(",");
      }
      params.checkState = params.checkState.toString();
      const { data } = await getPageListFn(params);
      this.tableData = data.records;
      this.pagination.total = data.total;
    },

    async downloadFiles(row) {
      let param = {
        planId: row.planId,
        cardNo: row.cardNo,
        courseId: row.courseId,
      };
      const { data } = await catePrint(param);
      if (data) {
        window.open(data);
      }
    },
    exportScore() {
      let params = { ...this.stuSelectParams };
      if (typeof params.stationId == "object") {
        params.stationId = params.stationId.join(",");
      }
      params.checkState = params.checkState.join(",");
      exportDataimg(params).then((res) => {
        if (res.code == 1) {
          window.open(res.data);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped></style>
